// InMemorySearch.js
export class InMemorySearch {
  #worker;
  #req = 0;
  #pending = new Map();
  #ready;

  constructor({ id, fields, documents, workerURL } = {}) {
    // Use your bundler-friendly URL, or pass an explicit workerURL
    this.#worker = workerURL
      ? new Worker(workerURL, { type: "module" })
      : new Worker(new URL("./search.worker.js", import.meta.url), { type: "module" });

    this.refField = id;

    this.#worker.onmessage = (e) => {
      const { requestId, results, ok, error } = e.data || {};
      const pending = this.#pending.get(requestId);
      if (!pending) return;
      this.#pending.delete(requestId);
      if (error) pending.reject(new Error(error));
      else pending.resolve(results ?? ok);
    };

    // Build the index in the worker
    this.#ready = this.#rpc("init", { id, fields, documents });
  }

  terminate() {
    this.#worker?.terminate();
    for (const p of this.#pending.values()) {
      p.reject(new Error("Worker terminated"));
    }
    this.#pending.clear();
  }

  async index({ id, fields, documents }) {
    this.refField = id;
    return this.#rpc("reindex", { id, fields, documents });
  }

  indexDocument(doc) {
    return this.#rpc("add", { doc });
  }

  deleteDocument(idVal) {
    return this.#rpc("remove", { id: idVal });
  }

  async search(query) {
    await this.#ready; // ensure the index is ready
    return this.#rpc("search", { query });
  }

  // --- private ---
  #rpc(type, payload) {
    const requestId = ++this.#req;
    const promise = new Promise((resolve, reject) => {
      this.#pending.set(requestId, { resolve, reject });
    });
    this.#worker.postMessage({ requestId, type, payload });
    return promise;
  }
}
